import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const rateTermItemStyling: AbgSxProps = { fontSize: 'inherit' };

export const rateTermsNotesCommonStyling: AbgSxProps = {
  fontSize: 'inherit',
};

export const rateTermsNotesWrapperStyling: AbgSxProps = {
  paddingLeft: '30px',
  marginTop: '10px',
  marginBottom: '4px',
};

export const specialRateTermsNotesStyling: AbgSxProps = {
  ...rateTermsNotesCommonStyling,
  color: paletteBase.green400,
  display: 'flex',
  alignItems: 'center',
  lineHeight: '18px',
};

export const specialRateTermsIconStyling: AbgSxProps = {
  stroke: paletteBase.green400,
  width: '12px',
  strokeWidth: '1px',
  fontSize: '12px',
  marginRight: '4px',
};

export const rateTermsCapitalizedText: AbgSxProps = {
  textTransform: 'capitalize',
  fontSize: 'inherit',
};
